import '../scss/style.scss';
import '../scss/lib/swiper-bundle.min.css';

import fewScroll from './fewScroll';
import spMenuOpen from "./spMenuOpen";
import blockFade from "./blockfade";
import executeAboutSlider from "./executeAboutSlider";
import executePlanSlider from "./executePlanSlider";
import executeRoomSlider from "./executeRoomSlider";
import executeDiscoverSlider from "./executeDiscoverSlider";
import executeRoomModalSlider from "./executeRoomModalSlider";
import agreeCheck from "./agreeCheck";
import langChange from "./langChange";
langChange();
agreeCheck();
blockFade();
executeRoomModalSlider();
executeAboutSlider();
executePlanSlider();
executeRoomSlider();
executeDiscoverSlider();
spMenuOpen();
fewScroll();
